import axios from 'axios'

export default {
  state: {
    leaderboard: {},
  },
  getters: {
    getLeaderboard: (s) => s.leaderboard,
  },
  mutations: {
    setLeaderboard: (s, list) => (s.leaderboard = list),
  },
  actions: {
    fetchLeaderboard(ctx) {
      return axios({
        method: 'GET',
        url: `api/gamification/leaderboard/ `,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setLeaderboard', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
